// Yazılım ve teknik yetkinlik preset listesi (elektrik müh./proje disiplinine göre)
// Kullanım: profilde seviyeli chip olarak görünür. Kullanıcı elle de ekleyebilir.

const SKILL_LEVELS = [
  { value: 'beginner',      label: 'Başlangıç' },
  { value: 'intermediate',  label: 'Orta' },
  { value: 'advanced',      label: 'İleri' },
  { value: 'expert',        label: 'Uzman' },
];

const SKILL_CATEGORIES = [
  'CAD / Çizim',
  'BIM / 3D Modelleme',
  'Elektrik Proje Yazılımları',
  'Aydınlatma',
  'Güç Sistemi Analizi',
  'Simülasyon / Hesaplama',
  'Otomasyon / PLC / SCADA',
  'Enerji / Yenilenebilir',
  'HVAC / Bina Enerjisi',
  'Ofis & Dokümantasyon',
  'Proje Yönetimi',
  'CBS / GIS',
  'Programlama',
];

const SOFTWARE_SKILLS = [
  // ─── CAD / Çizim ─────────────────────────────────────────────────
  { id: 'autocad',              name: 'AutoCAD',                   category: 'CAD / Çizim' },
  { id: 'autocad-electrical',   name: 'AutoCAD Electrical',        category: 'CAD / Çizim' },
  { id: 'autocad-mep',          name: 'AutoCAD MEP',               category: 'CAD / Çizim' },
  { id: 'bricscad',             name: 'BricsCAD',                  category: 'CAD / Çizim' },
  { id: 'zwcad',                name: 'ZWCAD',                     category: 'CAD / Çizim' },
  { id: 'draftsight',           name: 'DraftSight',                category: 'CAD / Çizim' },
  { id: 'microstation',         name: 'MicroStation',              category: 'CAD / Çizim' },
  { id: 'netcad',               name: 'NetCAD',                    category: 'CAD / Çizim' },
  { id: 'sketchup',             name: 'SketchUp',                  category: 'CAD / Çizim' },

  // ─── BIM / 3D Modelleme ──────────────────────────────────────────
  { id: 'revit-mep',            name: 'Autodesk Revit MEP',        category: 'BIM / 3D Modelleme' },
  { id: 'revit-arch',           name: 'Autodesk Revit Architecture', category: 'BIM / 3D Modelleme' },
  { id: 'navisworks',           name: 'Navisworks',                category: 'BIM / 3D Modelleme' },
  { id: 'archicad',             name: 'ArchiCAD',                  category: 'BIM / 3D Modelleme' },
  { id: 'allplan-mep',          name: 'Allplan MEP',               category: 'BIM / 3D Modelleme' },
  { id: 'tekla',                name: 'Tekla Structures',          category: 'BIM / 3D Modelleme' },
  { id: 'plant-3d',             name: 'AutoCAD Plant 3D',          category: 'BIM / 3D Modelleme' },
  { id: 'bentley-openbuildings', name: 'Bentley OpenBuildings',    category: 'BIM / 3D Modelleme' },

  // ─── Elektrik Proje Yazılımları ──────────────────────────────────
  { id: 'bina-proje',           name: 'Bina Proje (bProje)',       category: 'Elektrik Proje Yazılımları' },
  { id: 'eplan-p8',             name: 'EPLAN Electric P8',         category: 'Elektrik Proje Yazılımları' },
  { id: 'eplan-pro-panel',      name: 'EPLAN Pro Panel',           category: 'Elektrik Proje Yazılımları' },
  { id: 'see-electrical',       name: 'SEE Electrical',            category: 'Elektrik Proje Yazılımları' },
  { id: 'elecdes',              name: 'Elecdes Design Suite',      category: 'Elektrik Proje Yazılımları' },
  { id: 'caneco',               name: 'Caneco BT / HT',            category: 'Elektrik Proje Yazılımları' },
  { id: 'hemup',                name: 'Hemup (Elektrik Hesap)',    category: 'Elektrik Proje Yazılımları' },
  { id: 'profesta',             name: 'Profesta',                  category: 'Elektrik Proje Yazılımları' },

  // ─── Aydınlatma ──────────────────────────────────────────────────
  { id: 'dialux-evo',           name: 'DIALux evo',                category: 'Aydınlatma' },
  { id: 'dialux',               name: 'DIALux',                    category: 'Aydınlatma' },
  { id: 'relux',                name: 'Relux',                     category: 'Aydınlatma' },
  { id: 'agi32',                name: 'AGi32',                     category: 'Aydınlatma' },

  // ─── Güç Sistemi Analizi ─────────────────────────────────────────
  { id: 'etap',                 name: 'ETAP',                      category: 'Güç Sistemi Analizi' },
  { id: 'digsilent',            name: 'DIgSILENT PowerFactory',    category: 'Güç Sistemi Analizi' },
  { id: 'pss-e',                name: 'PSS/E',                     category: 'Güç Sistemi Analizi' },
  { id: 'cyme',                 name: 'CYME',                      category: 'Güç Sistemi Analizi' },
  { id: 'skm-powertools',       name: 'SKM PowerTools',            category: 'Güç Sistemi Analizi' },
  { id: 'neplan',               name: 'NEPLAN',                    category: 'Güç Sistemi Analizi' },
  { id: 'easypower',            name: 'EasyPower',                 category: 'Güç Sistemi Analizi' },

  // ─── Simülasyon / Hesaplama ──────────────────────────────────────
  { id: 'matlab',               name: 'MATLAB / Simulink',         category: 'Simülasyon / Hesaplama' },
  { id: 'pscad',                name: 'PSCAD',                     category: 'Simülasyon / Hesaplama' },
  { id: 'psim',                 name: 'PSIM',                      category: 'Simülasyon / Hesaplama' },
  { id: 'multisim',             name: 'Multisim',                  category: 'Simülasyon / Hesaplama' },
  { id: 'proteus',              name: 'Proteus',                   category: 'Simülasyon / Hesaplama' },
  { id: 'ltspice',              name: 'LTspice',                   category: 'Simülasyon / Hesaplama' },
  { id: 'ansys-maxwell',        name: 'ANSYS Maxwell',             category: 'Simülasyon / Hesaplama' },
  { id: 'comsol',               name: 'COMSOL Multiphysics',       category: 'Simülasyon / Hesaplama' },

  // ─── Otomasyon / PLC / SCADA ─────────────────────────────────────
  { id: 'tia-portal',           name: 'Siemens TIA Portal',        category: 'Otomasyon / PLC / SCADA' },
  { id: 'step7',                name: 'Siemens STEP 7',            category: 'Otomasyon / PLC / SCADA' },
  { id: 'wincc',                name: 'Siemens WinCC',             category: 'Otomasyon / PLC / SCADA' },
  { id: 'studio5000',           name: 'Rockwell Studio 5000',      category: 'Otomasyon / PLC / SCADA' },
  { id: 'codesys',              name: 'CoDeSys',                   category: 'Otomasyon / PLC / SCADA' },
  { id: 'logo-soft',            name: 'LOGO! Soft Comfort',        category: 'Otomasyon / PLC / SCADA' },
  { id: 'labview',              name: 'LabVIEW',                   category: 'Otomasyon / PLC / SCADA' },
  { id: 'wonderware',           name: 'AVEVA (Wonderware) InTouch', category: 'Otomasyon / PLC / SCADA' },
  { id: 'ifix',                 name: 'GE iFIX / Proficy',         category: 'Otomasyon / PLC / SCADA' },
  { id: 'schneider-ecostruxure',name: 'Schneider EcoStruxure',     category: 'Otomasyon / PLC / SCADA' },

  // ─── Enerji / Yenilenebilir ──────────────────────────────────────
  { id: 'pvsyst',               name: 'PVsyst',                    category: 'Enerji / Yenilenebilir' },
  { id: 'helioscope',           name: 'HelioScope',                category: 'Enerji / Yenilenebilir' },
  { id: 'pv-sol',               name: 'PV*SOL',                    category: 'Enerji / Yenilenebilir' },
  { id: 'sam-nrel',             name: 'SAM (NREL)',                category: 'Enerji / Yenilenebilir' },
  { id: 'retscreen',            name: 'RETScreen',                 category: 'Enerji / Yenilenebilir' },
  { id: 'homer',                name: 'HOMER Pro',                 category: 'Enerji / Yenilenebilir' },

  // ─── HVAC / Bina Enerjisi ────────────────────────────────────────
  { id: 'bep-tr',               name: 'BEP-TR (Ulusal EKB)',       category: 'HVAC / Bina Enerjisi' },
  { id: 'hap',                  name: 'Carrier HAP',               category: 'HVAC / Bina Enerjisi' },
  { id: 'energyplus',           name: 'EnergyPlus',                category: 'HVAC / Bina Enerjisi' },
  { id: 'equest',               name: 'eQUEST',                    category: 'HVAC / Bina Enerjisi' },
  { id: 'designbuilder',        name: 'DesignBuilder',             category: 'HVAC / Bina Enerjisi' },
  { id: 'ies-ve',               name: 'IES VE',                    category: 'HVAC / Bina Enerjisi' },

  // ─── Ofis & Dokümantasyon ────────────────────────────────────────
  { id: 'excel',                name: 'Microsoft Excel',           category: 'Ofis & Dokümantasyon' },
  { id: 'word',                 name: 'Microsoft Word',            category: 'Ofis & Dokümantasyon' },
  { id: 'powerpoint',           name: 'Microsoft PowerPoint',      category: 'Ofis & Dokümantasyon' },
  { id: 'outlook',              name: 'Microsoft Outlook',         category: 'Ofis & Dokümantasyon' },
  { id: 'access',               name: 'Microsoft Access',          category: 'Ofis & Dokümantasyon' },
  { id: 'visio',                name: 'Microsoft Visio',           category: 'Ofis & Dokümantasyon' },
  { id: 'google-workspace',     name: 'Google Workspace (Docs/Sheets)', category: 'Ofis & Dokümantasyon' },
  { id: 'libreoffice',          name: 'LibreOffice',               category: 'Ofis & Dokümantasyon' },
  { id: 'adobe-acrobat',        name: 'Adobe Acrobat Pro',         category: 'Ofis & Dokümantasyon' },

  // ─── Proje Yönetimi ──────────────────────────────────────────────
  { id: 'ms-project',           name: 'Microsoft Project',         category: 'Proje Yönetimi' },
  { id: 'primavera-p6',         name: 'Primavera P6',              category: 'Proje Yönetimi' },
  { id: 'jira',                 name: 'Jira',                      category: 'Proje Yönetimi' },
  { id: 'asana',                name: 'Asana',                     category: 'Proje Yönetimi' },
  { id: 'trello',               name: 'Trello',                    category: 'Proje Yönetimi' },
  { id: 'monday',               name: 'Monday.com',                category: 'Proje Yönetimi' },
  { id: 'notion',               name: 'Notion',                    category: 'Proje Yönetimi' },

  // ─── CBS / GIS ──────────────────────────────────────────────────
  { id: 'arcgis',               name: 'ArcGIS',                    category: 'CBS / GIS' },
  { id: 'qgis',                 name: 'QGIS',                      category: 'CBS / GIS' },
  { id: 'autocad-map3d',        name: 'AutoCAD Map 3D',            category: 'CBS / GIS' },
  { id: 'google-earth-pro',     name: 'Google Earth Pro',          category: 'CBS / GIS' },

  // ─── Programlama ────────────────────────────────────────────────
  { id: 'python',               name: 'Python',                    category: 'Programlama' },
  { id: 'vba',                  name: 'VBA (Excel/Access makro)',  category: 'Programlama' },
  { id: 'cpp',                  name: 'C / C++',                   category: 'Programlama' },
  { id: 'csharp',               name: 'C#',                        category: 'Programlama' },
  { id: 'java',                 name: 'Java',                      category: 'Programlama' },
  { id: 'javascript',           name: 'JavaScript',                category: 'Programlama' },
  { id: 'sql',                  name: 'SQL',                       category: 'Programlama' },
  { id: 'lua',                  name: 'Ladder Logic',              category: 'Programlama' },
];

export { SOFTWARE_SKILLS, SKILL_CATEGORIES, SKILL_LEVELS };
